import axios from "axios";

export const getSocials = async () => {
	return axios.get("/socials")
		.catch(err => err);
};